module.exports = __webpack_public_path__ + "static/gm-44-4875e1bcda33f6481589811cea0a1273.jpg";